import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { storage, useRequest } from "../../utils";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";

import utils from "../../components/toastify/toastify";

const EditCategory = (props) => {
  const [data, set_data] = useState(null);

  const [
    get_sub_categories_error,
    get_sub_categories_loading,
    get_sub_categories_data,
    get_sub_categories_function,
  ] = useRequest({
    method: "get",
    url: "/get_sub_categories",
  });

  const [
    get_category_by_id_error,
    get_category_by_id_loading,
    get_category_by_id_data,
    get_category_by_id_function,
  ] = useRequest({
    method: "post",
    url: "/get_category_by_id",
    isFunction: true,
  });
  useEffect(() => {
    if (props.match.params.id) {
      get_category_by_id_function({
        category_id: props.match.params.id,
      }).then((res) => set_data(res.data));
    }
  }, [props.match.params.id]);

  const [title, setTitle] = useState("");
  const [category_id, set_category_id] = useState("");

  const [less_description_title, set_less_description_title] = useState("");
  const [description, setDescription] = useState("<p>توضیح دسته بندی </p>");
  const [less_description, set_less_description] =
    useState("<p>توضیح کوتاه</p>");
  const [content_img, set_content_img] = useState("");

  useEffect(() => {
    if (data) {
      get_sub_categories_function({}).then(() => {
        set_category_id(data.sub_category_id);
        setTitle(data.title);
        set_less_description_title(data.less_description_title);
        setDescription(data.description);
        set_less_description(data.less_description);
      });
    }
  }, [data]);

  let history = useHistory();

  const sendData = () => {
    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });

    const formData = new FormData();

    formData.append("logo_img", content_img);
    formData.append("title", title);
    formData.append("less_description_title", less_description_title);
    formData.append("less_description", less_description);
    formData.append("description", description);
    formData.append("sub_category_id", category_id);
    formData.append("category_id", props.match.params.id);
    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/edit_category", formData, {
        headers: {
          "x-auth": res,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          console.log(res);
          $.unblockUI();
          history.push("/dashboard/showCategories");
        })
        .catch((err) => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
        });
    });
  };

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">ویرایش دسته بندی </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">افزودن دسته بندی جدید</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              {get_sub_categories_data ? (
                                <div class="row">
                                  <div class="col-md-6">
                                    <h6>دسته بندی اصلی</h6>
                                    <fieldset class="form-group">
                                      <select
                                        class="custom-select"
                                        id="customSelect"
                                        value={category_id}
                                        onChange={(e) =>
                                          set_category_id(e.target.value)
                                        }
                                      >
                                        <option selected value="">
                                          دسته بندی اصلی را انتخاب کنید
                                        </option>
                                        {get_sub_categories_data.data.map(
                                          (i) => (
                                            <option value={i._id}>
                                              {i.title}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </fieldset>
                                  </div>
                                </div>
                              ) : null}
                              {category_id ? (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="عنوان دسته بندی "
                                      value={title}
                                      onChange={(e) => setTitle(e.target.value)}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder="عنوان توضیح کوتاه"
                                        value={less_description_title}
                                        onChange={(e) =>
                                          set_less_description_title(
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                  <CKEditor
                                    editor={ClassicEditor}
                                    data={less_description}
                                    config={{
                                      // Use the German language for this editor.
                                      language: "fa",

                                      // ...
                                    }}
                                    // onReady={(editor) => {
                                    //   // You can store the "editor" and use when it is needed.
                                    //   console.log(
                                    //     "Editor is ready to use!",
                                    //     editor
                                    //   );
                                    // }}

                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      set_less_description(data);
                                    }}
                                    // onBlur={(event, editor) => {
                                    //   console.log("Blur.", editor);
                                    // }}
                                    // onFocus={(event, editor) => {
                                    //   console.log("Focus.", editor);
                                    // }}
                                  />
                                  <div style={{ marginTop: "10px" }} />
                                  <CKEditor
                                    editor={ClassicEditor}
                                    data={description}
                                    config={{
                                      // Use the German language for this editor.
                                      language: "fa",

                                      // ...
                                    }}
                                    // onReady={(editor) => {
                                    //   // You can store the "editor" and use when it is needed.
                                    //   console.log(
                                    //     "Editor is ready to use!",
                                    //     editor
                                    //   );
                                    // }}

                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      setDescription(data);
                                    }}
                                    // onBlur={(event, editor) => {
                                    //   console.log("Blur.", editor);
                                    // }}
                                    // onFocus={(event, editor) => {
                                    //   console.log("Focus.", editor);
                                    // }}
                                  />

                                  <div class="row">
                                    <div class="col-md-6">
                                      <fieldset>
                                        <h6>تصویر محتوای محصول</h6>
                                        <div class="input-group">
                                          <div class="input-group-prepend"></div>
                                          <div class="input-group">
                                            <div class="custom-file">
                                              <input
                                                type="file"
                                                class="custom-file-input"
                                                id="inputGroupFile02"
                                                onChange={(e) =>
                                                  set_content_img(
                                                    e.target.files[0]
                                                  )
                                                }
                                              />
                                              <label
                                                class="custom-file-label"
                                                for="inputGroupFile02"
                                                aria-describedby="inputGroupFileAddon02"
                                              >
                                                {content_img
                                                  ? content_img.name
                                                  : "انتخاب فایل"}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {category_id ? (
                <button
                  onClick={() => {
                    sendData();
                  }}
                  style={{
                    marginTop: "-2rem",
                    marginRight: "25px",
                    width: "fit-content",
                  }}
                  type="button"
                  class="btn btn-success mr-1 mb-1 "
                >
                  ویرایش دسته بندی
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { EditCategory };
